module.exports = __webpack_public_path__ + "static/media/lawfirm.be5be76d.png";